module.exports = __webpack_public_path__ + "img/cnu_main1.10fdfb79.jpg";